import { Spinner } from "@fluentui/react-components";
import { useRichiesta } from "../../data/useRichiesta";
import { goBack } from "../../lib/nav";
import { formatDateTime } from "../../lib/format";
import { Shell } from "../../components/Shell";
import { RichiestaInfo } from "../../components/RichiestaInfo";
import { InfoRow, Section } from "../../components/Section";
import { ErrorState } from "../../components/ErrorState";

/** Dettaglio in sola lettura: dopo l'invio il richiedente può solo seguire lo stato. */
export function DettaglioRichiedente({ id }: { id: number }) {
  const { item, error } = useRichiesta(id);
  return (
    <Shell title={`Richiesta #${id}`} onBack={goBack}>
      {error ? (
        <ErrorState error={error} />
      ) : item === undefined ? (
        <Spinner style={{ marginTop: 48 }} />
      ) : item === null ? (
        <ErrorState error={new Error("Richiesta non trovata o non accessibile.")} />
      ) : (
        <>
          <RichiestaInfo r={item} />
          {(item.fields.NoteGestore || item.fields.DataChiusura) && (
            <Section title="Dal gestore">
              {item.fields.NoteGestore && <InfoRow label="Note">{item.fields.NoteGestore}</InfoRow>}
              {item.fields.DataChiusura && <InfoRow label="Chiusa il">{formatDateTime(item.fields.DataChiusura)}</InfoRow>}
            </Section>
          )}
        </>
      )}
    </Shell>
  );
}
